import {
  INICIA_TURMA,
  NOVO_TURMA,
  BUSCA_TURMA_EDICAO,
  CANCELA_EDICAO,
  INICIO_TURMA_SUCESSO,
  SALVA_TURMA_SUCESSO,
  REMOVE_TURMA_SUCESSO,
  BUSCA_TURMA_EDICAO_SUCESSO,
  INIT_URL,
  HIDE_MESSAGE,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  ON_SHOW_SUCCESS_MESSAGE,
  ON_SHOW_ERROR_MESSAGE,
  SHOW_MESSAGE,
  ALTERACAO_CAMPO,
  ALTERACAO_COMBO,
  ALTERACAO_DATEPICKER,
  ALTERACAO_CHECK,
  LISTA_TURMA,
  LISTA_TURMA_SUCESSO,
  LIMPAR_TURMA,
  LISTA_CURSOS_POR_ESCOLA_TURMA_SUCESSO,
  LISTA_SERIES_POR_CURSO_TURMA_SUCESSO,
  LISTA_ESCOLAS_TURMA_SUCESSO,
  LISTA_ANOS_LETIVOS_POR_ESCOLA_TURMA_SUCESSO,
  LISTA_TIPOS_TURMA_SUCESSO,
  GET_DISCIPLINAS_TURMA_SUCCESS,
  APLICA_FILTRO_TURMA
} from "constants/ActionTypes";

const normalizeTurmaListItem = (t) => {
  const id = t.id || t.Id || 0;
  const nome = t.nome || t.Nome || '';
  const ano = t.ano || t.Ano || '';
  const escolaNome = t.escolaNome || t.EscolaNome || '';
  const cursoNome = t.cursoNome || t.CursoNome || '';
  const serieNome = t.serieNome || t.SerieNome || '';
  const turno = t.turno || t.Turno || null;
  const estaAtiva = (t.estaAtiva !== undefined ? t.estaAtiva : (t.EstaAtiva !== undefined ? t.EstaAtiva : (t.ativo !== undefined ? t.ativo : (t.Ativo !== undefined ? t.Ativo : false))));
  return { ...t, id, nome, ano, escolaNome, cursoNome, serieNome, turno, estaAtiva };
};

const toHHMM = (v) => {
  if (v === undefined || v === null) return '';
  const s = String(v);
  const base = s.replace(/:\d{2}$/,'').replace(/:\d{2}:\d{2}$/,'');
  const partes = base.split(':');
  const hh = (partes[0] || '').padStart(2,'0').slice(-2);
  const mm = (partes[1] || '').padStart(2,'0').slice(-2);
  return `${hh}:${mm}`;
};

const INIT_STATE = {
  colunasGrid: [
    { titulo: 'Código', propriedadeApi: 'id', alinhamento: 'left' },
    { titulo: 'Turma', propriedadeApi: 'nome', alinhamento: 'left' },
    { titulo: 'Escola', propriedadeApi: 'escolaNome', alinhamento: 'left' },
    { titulo: 'Curso', propriedadeApi: 'cursoNome', alinhamento: 'left' },
    { titulo: 'Série', propriedadeApi: 'serieNome', alinhamento: 'left' },
    { titulo: 'Turno', propriedadeApi: 'turno', alinhamento: 'left' },
    { titulo: 'Ativa', propriedadeApi: 'estaAtiva', alinhamento: 'left', booleano: true },
    { titulo: 'Ano', propriedadeApi: 'ano', alinhamento: 'left' },
  ],

  loader: false,
  alertMessage: '',
  showMessageSuccess: false,
  showMessageError: false,
  edicao: false,
  carregandoLista: true,
  listGrid: [],
  listGridComFiltro: [],
  textoFiltro: '',
  turmaCarregada: null,

  id: 0,
  ano: '',
  escolaId: null,
  cursoId: null,
  serieId: null,
  professorId: null,
  turmaTipoId: null,
  nome: '',
  sigla: '',
  maxAluno: 0,
  estaAtiva: true,
  mediacaoTipo: null,
  horaInicial: '',
  horaInicioIntervalo: '',
  horaFimIntervalo: '',
  horaFinal: '',
  diasSemana: [],
  turno: null,
  tipoBoletim: null,
  multiProfessor: false,
  professores: [],

  listaEscolas: [],
  listaCursosPorEscola: [],
  listaSeriesPorCurso: [],
  listaAnosLetivosPorEscola: [],
  listaTiposTurma: [],
  disciplinasDisponiveis: [],

  nomeTurmaFiltro: '',
  anoLetivoFiltro: ''
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case INICIA_TURMA: {
      return { ...state, edicao: false, loader: true, carregandoLista: true };
    }
    case NOVO_TURMA: {
      return {
        ...state,
        edicao: true,
        loader: false,
        id: 0,
        ano: '',
        escolaId: null,
        cursoId: null,
        serieId: null,
        professorId: null,
        turmaTipoId: null,
        nome: '',
        sigla: '',
        maxAluno: 0,
        estaAtiva: true,
        mediacaoTipo: null,
        horaInicial: '',
        horaInicioIntervalo: '',
        horaFimIntervalo: '',
        horaFinal: '',
        diasSemana: [],
        turno: null,
        tipoBoletim: null,
        disciplinasDisponiveis: [],
        multiProfessor: false,
        professores: [],
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
      };
    }
    case BUSCA_TURMA_EDICAO: {
      return { ...state, loader: true };
    }
    case CANCELA_EDICAO: {
      return { ...state, edicao: false };
    }
    case INICIO_TURMA_SUCESSO: {
      const retorno = action.payload || [];
      const lista = Array.isArray(retorno)
        ? retorno
        : (retorno && (retorno.turma || retorno.Turma || retorno.turmas || retorno.Turmas)
            ? (retorno.turma || retorno.Turma || retorno.turmas || retorno.Turmas)
            : []);
      const listaNorm = Array.isArray(lista) ? lista.map(normalizeTurmaListItem) : [];
      return { ...state, loader: false, carregandoLista: false, listGrid: listaNorm, listGridComFiltro: listaNorm };
    }
    case SALVA_TURMA_SUCESSO: {
      return { ...state, loader: false, alertMessage: action.payload, showMessageSuccess: true, edicao: false };
    }
    case REMOVE_TURMA_SUCESSO: {
      return { ...state, loader: false, alertMessage: action.payload, showMessageSuccess: true, edicao: false };
    }
    case LISTA_TURMA: {
      return { ...state, loader: true, carregandoLista: true };
    }
    case APLICA_FILTRO_TURMA: {
      const texto = action.payload || '';
      return { ...state, textoFiltro: texto };
    }
    case LISTA_TURMA_SUCESSO: {
      const retorno = action.payload;
      const lista = Array.isArray(retorno)
        ? retorno
        : (retorno && (retorno.turma || retorno.Turma || retorno.turmas || retorno.Turmas)
            ? (retorno.turma || retorno.Turma || retorno.turmas || retorno.Turmas)
            : []);
      const listaNorm = Array.isArray(lista) ? lista.map(normalizeTurmaListItem) : [];
      return { ...state, loader: false, carregandoLista: false, listGrid: listaNorm, listGridComFiltro: listaNorm };
    }
    case LISTA_ESCOLAS_TURMA_SUCESSO: {
      const escolasRaw = action.payload?.escolas || action.payload || [];
      const listaEscolas = Array.isArray(escolasRaw)
        ? escolasRaw.map(e => ({ id: e.id || e.Id, title: e.nome || e.Nome }))
        : [];
      return { ...state, listaEscolas };
    }
    case LISTA_CURSOS_POR_ESCOLA_TURMA_SUCESSO: {
      const cursosRaw = action.payload?.cursos || action.payload || [];
      const listaCursosPorEscola = Array.isArray(cursosRaw)
        ? cursosRaw.map(c => {
            const id = (c && (c.id || c.Id || c.cursoId || c.CursoId)) !== undefined
              ? (c.id || c.Id || c.cursoId || c.CursoId)
              : ((typeof c === 'number' || typeof c === 'string') ? c : 0);
            const nome = c && (c.nome || c.Nome || c.descricao || c.Descricao || c.titulo || c.Titulo || c.nomeCurso || c.NomeCurso || c.descricaoCurso || c.DescricaoCurso);
            const title = String(nome !== undefined && nome !== null ? nome : (id !== undefined ? id : ''));
            return { id, title };
          })
        : [];
      return { ...state, listaCursosPorEscola };
    }
    case LISTA_SERIES_POR_CURSO_TURMA_SUCESSO: {
      const seriesRaw = action.payload?.series || action.payload || [];
      const listaSeriesPorCurso = Array.isArray(seriesRaw)
        ? seriesRaw.map(s => {
            const id = (s && (s.id || s.Id || s.serieId || s.SerieId)) !== undefined
              ? (s.id || s.Id || s.serieId || s.SerieId)
              : ((typeof s === 'number' || typeof s === 'string') ? s : 0);
            const nome = s && (s.nome || s.Nome || s.descricao || s.Descricao || s.titulo || s.Titulo || s.nomeSerie || s.NomeSerie || s.descricaoSerie || s.DescricaoSerie);
            const title = String(nome !== undefined && nome !== null ? nome : (id !== undefined ? id : ''));
            return { id, title };
          })
        : [];
      return { ...state, listaSeriesPorCurso };
    }
    case LISTA_ANOS_LETIVOS_POR_ESCOLA_TURMA_SUCESSO: {
      const anosRaw = action.payload?.anos || action.payload || [];
      const listaAnosLetivosPorEscola = Array.isArray(anosRaw)
        ? anosRaw.map(a => {
            const anoVal = (
              a.ano != null ? a.ano :
              a.Ano != null ? a.Ano :
              a.descricao != null ? a.descricao :
              a.Descricao != null ? a.Descricao :
              a.id != null ? a.id :
              a.Id != null ? a.Id : ''
            );
            const status = a.status || a.Status || '';
            const id = anoVal; // o id da opção será o próprio ano
            const title = String(anoVal || '');
            return { id, title, status };
          })
        : [];
      return { ...state, listaAnosLetivosPorEscola };
    }
    case LISTA_TIPOS_TURMA_SUCESSO: {
      const tiposRaw = action.payload?.tipos || action.payload || [];
      const listaTiposTurma = Array.isArray(tiposRaw)
        ? tiposRaw.map(t => ({ id: t.id || t.Id, title: t.titulo || t.Titulo, sigla: t.sigla || t.Sigla }))
        : [];
      return { ...state, listaTiposTurma };
    }
    case GET_DISCIPLINAS_TURMA_SUCCESS: {
      const disciplinasDisponiveis = action.payload?.disciplinas || action.payload || [];
      return { ...state, disciplinasDisponiveis };
    }
    case LIMPAR_TURMA: {
      return { 
        ...state, 
        nomeTurmaFiltro: '', 
        textoFiltro: '',
        escolaFiltroTurma: null,
        cursoFiltroTurma: null,
        serieFiltroTurma: null,
        anoLetivoFiltroTurma: null,
        listaCursosPorEscola: [], // Limpa listas dependentes
        listaSeriesPorCurso: [],
        listaAnosLetivosPorEscola: []
      };
    }
    case BUSCA_TURMA_EDICAO_SUCESSO: {
      const retorno = action.payload;
      const base = retorno && retorno.turma ? retorno.turma : retorno;
      return {
        ...state,
        edicao: true,
        loader: false,
        turmaCarregada: base,
        id: base.id || base.Id || 0,
        ano: base.ano || base.Ano || '',
        escolaId: base.escolaId || base.escola_id || base.EscolaId || null,
        cursoId: base.cursoId || base.curso_id || base.CursoId || null,
        serieId: base.serieId || base.serie_id || base.SerieId || null,
        professorId: base.professorId || base.professor_id || base.ProfessorId || null,
        turmaTipoId: base.turmaTipoId || base.turma_tipo_id || base.TurmaTipoId || null,
        nome: base.nome || base.Nome || '',
        sigla: base.sigla || base.Sigla || '',
        maxAluno: base.maxAluno || base.MaxAluno || 0,
        estaAtiva: base.estaAtiva || base.EstaAtiva || base.ativo || base.Ativo || false,
        mediacaoTipo: base.mediacaoTipo || base.MediacaoTipo || null,
        horaInicial: toHHMM(base.horaInicial || base.HoraInicial || ''),
        horaInicioIntervalo: toHHMM(base.horaInicioIntervalo || base.HoraInicioIntervalo || ''),
        horaFimIntervalo: toHHMM(base.horaFimIntervalo || base.HoraFimIntervalo || ''),
        horaFinal: toHHMM(base.horaFinal || base.HoraFinal || ''),
        diasSemana: Array.isArray(base.diasSemana) ? base.diasSemana
          : Array.isArray(base.DiasSemana) ? base.DiasSemana
          : Array.isArray(base.dias_semana) ? base.dias_semana
          : [],
        turno: base.turno || base.Turno || null,
        tipoBoletim: base.tipoBoletim || base.TipoBoletim || null,
        multiProfessor: base.multiProfessor || base.MultiProfessor || false,
        professores: Array.isArray(base.professores) ? base.professores : (Array.isArray(base.Professores) ? base.Professores : []),
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
      };
    }
    case INIT_URL: {
      return { ...state, initURL: action.payload };
    }
    case HIDE_MESSAGE: {
      return { ...state, alertMessage: '', showMessageSuccess: false, showMessageError: false, loader: false, carregandoLista: false };
    }
    case ON_HIDE_LOADER: {
      return { ...state, loader: false, carregandoLista: false };
    }
    case ON_SHOW_LOADER: {
      return { ...state, loader: true };
    }
    case ON_SHOW_ERROR_MESSAGE: {
      return { ...state, loader: false, alertMessage: action.payload, showMessageError: true, edicao: false, carregandoLista: false };
    }
    case ON_SHOW_SUCCESS_MESSAGE: {
      return { ...state, loader: false, alertMessage: action.payload, showMessageSuccess: true, edicao: state.edicao, carregandoLista: false };
    }
    case SHOW_MESSAGE: {
      return { ...state, alertMessage: action.payload, showMessageError: true, loader: false, carregandoLista: false };
    }
    case ALTERACAO_CAMPO: {
      return { ...state, [action.payload.target.name]: action.payload.target.value };
    }
    case ALTERACAO_COMBO: {
      const valorBruto = action.payload.valor;
      const valorNormalizado = (valorBruto && typeof valorBruto === 'object')
        ? (valorBruto.id !== undefined ? valorBruto.id : (valorBruto.value !== undefined ? valorBruto.value : valorBruto))
        : valorBruto;
      const chave = action.payload.nomeCombo;
      // Quando cursoId/serieId forem atualizados, mantenha apenas o id no estado,
      // mas certifique-se de que a lista associada contenha objetos com title correto
      return { ...state, [chave]: valorNormalizado };
    }
    case ALTERACAO_CHECK: {
      const retorno = action.payload;
      const chave = retorno.nomeCheck !== undefined ? retorno.nomeCheck : retorno.name;
      const valor = retorno.valor !== undefined ? retorno.valor : retorno.value;
      return { ...state, [chave]: valor };
    }
    case ALTERACAO_DATEPICKER: {
      const nome = action.payload.name;
      const valor = action.payload.value !== undefined ? action.payload.value : action.payload.date;
      return { ...state, [nome]: valor };
    }
    default:
      return state;
  }
}
